// extracted by mini-css-extract-plugin
export default {"navFooter":"Footer_navFooter__CPH2B","boxInfo":"Footer_boxInfo__NTU23","dingo":"Footer_dingo__peehL","icon":"Footer_icon__Zscac","btn_social":"Footer_btn_social__yILsD"};